<template>
  <div class="pa-login-modal">
    <transition name="login-modal-content">
      <div class="pa-login-modal-content" v-if="isContentOpen">
        <LoginBox />
      </div>
    </transition>

    <transition name="login-modal-overlay">
      <div class="pa-login-modal-overlay" v-if="isOverlayOpen"></div>
    </transition>
  </div>
</template>

<script>
import LoginBox from '@/components/FrontParts/LoginModal/LoginBox/LoginBox.vue'

export default {
  components : {
    LoginBox
  },
  data(){
    return {
      isContentOpen : false,
      isOverlayOpen : false,
    };
  },

  mounted(){
    this.$parent.$on('closeLoginModal', () => {
      this.isContentOpen = false;
      this.isOverlayOpen = false;
    });

    this.$parent.$on('openLoginModal', () => {
      this.isContentOpen = true;
      this.isOverlayOpen = true;
    });
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "~bulma/sass/utilities/_all";

@keyframes loginModalOverlay
{
  0%   {
    transform:scale(.98);
    opacity:0;
    backdrop-filter: blur(0px);
  }
  100% {
    transform:scale(1);
    opacity:.6;
    backdrop-filter: blur(3px);
  }
}

@keyframes fadeInOverlayFull
{
  0%  {
    transform:scale(.98);
    opacity:0;
  }
  100% {
    transform:scale(1);
    opacity:1;
  }
}

div.pa-login-modal{
  .login-modal-overlay{
    &-enter-active{
      animation: loginModalOverlay .8s ease-in-out;
    }

    &-leave-active{
      animation: loginModalOverlay .8s ease-in-out reverse;
    }

    &-enter, &-leave-to{
      opacity: 0;
    }
  }

  .login-modal-content{
    &-enter-active{
      animation: fadeInOverlayFull ease-in-out .8s;
    }

    &-leave-active{
      animation: fadeInOverlayFull .8s ease-in-out reverse;
    }

    &-enter, &-leave-to{
      opacity: 0;
    }
  }

  div.pa-login-modal-content{
    position: fixed;
    top:0;
    left:0;
    background-color: inherit;
    z-index: 10;
    width:100vw;
    height:100vh;
    color: #ffffff;

    @include from($tablet) {
      display:flex;
      justify-content: center;
      align-items: center;
    }
  }

  div.pa-login-modal-overlay{
    position: fixed;
    top:0;
    left:0;
    z-index: 9;
    width: 100vw;
    height: 100vh;
    background-color:black;
    background: radial-gradient(#2C2C2C, #000000, 60%);
    opacity:.6;
    backdrop-filter: blur(3px);
  }
}
</style>